import { createApi } from '@reduxjs/toolkit/query/react';
import { APICall } from '@/config/NetworkUtility';

const customBaseQuery = async ({ url, method, body, params }) => {
    try {
        const query = params
            ? new URLSearchParams(params).toString()
            : '';

        const endpoint = query
            ? `${url}?${query}`
            : url;

        const result = await APICall(
            method,
            body ?? null,
            endpoint
        );

        return {
            data: result,
        };
    } catch (error) {
        return {
            error: {
                status: error?.response?.status || 500,
                data:
                    error?.response?.data ||
                    error?.message ||
                    'Request failed',
            },
        };
    }
};

export const applicableChargesApi = createApi({
    reducerPath: 'applicableChargesApi',
    baseQuery: customBaseQuery,
    tagTypes: ['ApplicableCharges'],

    endpoints: (builder) => ({

        // ============================================
        // GET APPLICABLE CHARGES
        // ============================================

        getApplicableCharges: builder.query({
            query: (params = {}) => ({
                url: 'v1/MasterIfApplicable/GetMasterIfApplicableCharge',
                method: 'get',
                params,
            }),

            transformResponse: (response) =>
                response?.data || response || [],

            providesTags: ['ApplicableCharges'],
        }),

        // ============================================
        // CREATE APPLICABLE CHARGE
        // ============================================

        createApplicableCharge: builder.mutation({
            query: (payload) => ({
                url: 'v1/MasterIfApplicable/CreateIfApplicableCharge',
                method: 'post',
                body: payload,
            }),

            transformResponse: (response) =>
                response?.data || response,

            invalidatesTags: ['ApplicableCharges'],
        }),

        // ============================================
        // UPDATE APPLICABLE CHARGE
        // ============================================

        updateApplicableCharge: builder.mutation({
            query: (payload) => ({
                url: 'v1/MasterIfApplicable/UpdateIfApplicableCharge',
                method: 'post',
                body: payload,
            }),

            transformResponse: (response) =>
                response?.data || response,

            invalidatesTags: ['ApplicableCharges'],
        }),

        // ============================================
        // GET APPLICABLE CHARGE WRT MODE
        // ============================================

        getApplicableChargeWRTMode: builder.query({
            query: ({
                CompanyId,
                Module,
                Mode,
            }) => ({
                url: 'v1/MasterIfApplicable/GetMasterIfApplicableChargeWRTMode',
                method: 'get',
                params: {
                    CompanyId,
                    Module,
                    Mode,
                },
            }),

            transformResponse: (response) =>
                response?.data || response || [],

            providesTags: ['ApplicableCharges'],
        }),
    }),
});

export const {
    useGetApplicableChargesQuery,
    useCreateApplicableChargeMutation,
    useUpdateApplicableChargeMutation,
    useGetApplicableChargeWRTModeQuery,
} = applicableChargesApi;